import React, { useState, useEffect } from "react";
import ButtonComponent from "./ButtonComponent";
import { useTranslation } from "react-i18next";

const BookingSummary = ({
  bookingLockerHandler,
  selectedLockers,
  address,
  lockerCurrency = "INR",
  handleLockerBooking = () => {},
}) => {
  const { t } = useTranslation();
  const [updatedLockers, setUpdatedLockers] = useState(selectedLockers || []);
  const [totalPrice, setTotalPrice] = useState(0);
    
  console.log("selectedLockers in BookingSummary: ", selectedLockers);

  // Sync lockers
  useEffect(() => {
    setUpdatedLockers(selectedLockers || []);
  }, [selectedLockers]);

  const lockerList = updatedLockers || [];

  const handlerCLick = () => {
    bookingLockerHandler();
  };

  const handlePayment = () => {
    console.log(" Final Payload:", lockerList, "Total:", totalPrice);
    handleLockerBooking(lockerList, totalPrice);
  };

  // TOTAL PRICE CALCULATION (FIXED + FALLBACK)
  useEffect(() => {
    const total = lockerList.reduce((sum, item) => {
      return (
        sum +
        Number(
          item?.selectedSlot?.price ||     // selected slot price
          item?.durations?.[0]?.price ||   // fallback duration price
          item?.price || 0                 // base fallback
        )
      );
    }, 0);

    setTotalPrice(total);
  }, [lockerList]);

  return (
    <div className="booking-summary">
      <h2 className="title">
        {t("booking_summary_confirm_details_title")}
      </h2>

      <div className="location">
        {address ? address : "Pune"}
      </div>

      <div className="locker-list">
        {lockerList.map((locker) => (
          <div className="locker-card" key={locker.id}>
            <div className="locker-info">
              <span className="locker-name">{locker.name}</span>

              {/* SLOT BUTTON */}
              {locker?.bookingSlots ? (
                <button className="choose-slot-btn" disabled>
                  {locker.selectedSlot
                    ? locker.selectedSlot.durationRange
                    : t("slot_not_selected")}
                </button>
              ) : (
                <div className="time-select">
                  {locker.durations?.map((duration, index) => (
                    <p key={index}>
                      {duration.label}
                    </p>
                  ))}
                </div>
              )}

              {/* PRICE */}
              <span className="price">
                {` ${lockerCurrency} `}
                {locker?.selectedSlot?.price ||
                  locker?.durations?.[0]?.price ||
                  locker?.price}
              </span>
            </div>
          </div>
        ))}

        {/* ADD LOCKER */}
        <div className="add-locker" onClick={handlerCLick}>
          {t("add_another_update_selected_locker")}
        </div>

        {/* TOTAL */}
        <div className="total-section">
          <span>{t("total_payable_amount")}</span>
          <span className="total-price"> {` ${lockerCurrency}  `} {totalPrice}</span>
        </div>
      </div>

      {/* BUTTONS */}
      <div className="buttons">
        <ButtonComponent 
          type="primary" 
          handleClick={handlePayment}
          title={"proceed_to_pay"}
        />
      </div>

    </div>
  );
};

export default BookingSummary;
